import React from 'react';
import Icon from '../../../components/AppIcon';

const CompanyLogo = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo Icon */}
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 bg-primary rounded-xl flex items-center justify-center shadow-elevated">
          <Icon name="Wrench" size={32} color="white" />
        </div>
      </div>
      
      {/* Company Name */}
      <h1 className="text-3xl font-bold text-foreground mb-2">
        Ragna Detailing
      </h1>

      {/* Subtitle */}
      <p className="text-sm text-muted-foreground mt-2">
        Melden Sie sich an, um Ihre Termine zu verwalten
      </p>
    </div>
  );
};

export default CompanyLogo;